import NiceModal from '@ebay/nice-modal-react';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { AdminNavbar } from './AdminNavbar';

export const AdminLayout = () => {
  return (
    <NiceModal.Provider>
      <ChakraV3.Stack h='full' gap={0}>
        <AdminNavbar />
        <ChakraV3.Stack h='full' flexGrow={1} overflowY='auto' bg='white'>
          <Outlet />
        </ChakraV3.Stack>
      </ChakraV3.Stack>
    </NiceModal.Provider>
  );
};
